export const sortData = (arr, keys, orders) => {
  if (!arr || !(arr instanceof Array)) {
    return arr
  }
  if (keys instanceof Object && !(keys instanceof Array)) {
    return arr
  }
  keys = keys instanceof Array ? keys : [keys]
  orders = orders instanceof Array ? orders : [orders]
  if (keys.length <= 0) {
    return arr
  }
  const sortBy = (keys, orders) => (o1, o2) => {
    let key = keys[0]
    let order = orders[0] !== 'desc' ? 1 : -1
    let co1 = key instanceof Function ? key(o1) : o1[key]
    let co2 = key instanceof Function ? key(o2) : o2[key]
    co1 = co1 instanceof Array ? co1.length : co1
    co2 = co2 instanceof Array ? co2.length : co2
    if (co1 < co2) {
      return -1 * order
    } else if (co1 > co2) {
      return 1 * order
    } else {
      return keys.length === 0 ? 0 : sortBy(keys.slice(1), orders.length > 0 ? orders.slice(1) : orders)(o1, o2)
    }
  }
  return [...arr].sort(sortBy(keys, orders))
}

export const imageReader = async (files, type = 'dataUrl', maxWidth, maxHeight) => {
  if (!files) {
    return
  }
  const getContent = file => new Promise(resolve => {
    let reader = new FileReader()
    reader.onload = async e => {
      let dataUrl = e.target.result.startsWith('data:image/') ? e.target.result : ''
      if (maxWidth || maxHeight || type === 'blob') {
        resolve(await this.imageUrlReader([dataUrl], type === 'dataUrl' ? 'blobUrl' : type, maxWidth, maxHeight))
      } else if (type === 'dataUrl') {
        resolve(dataUrl)
      } else {
        resolve('')
      }
    }
    reader.readAsDataURL(file)
  })
  let content = []
  for (let file of files) {
    content.push(await getContent(file))
  }
  return content
}

export const imageUrlReader = async (urls, type = 'blobUrl', maxWidth, maxHeight) => {
  if (!urls) {
    return
  }
  const getContent = url => new Promise(resolve => {
    let img = new Image()
    img.onload = e => {
      let canvas = document.createElement('canvas')
      let targetWidth = img.width
      let targetHeight = img.height
      maxWidth = maxWidth || img.width
      maxHeight = maxHeight || img.height
      if (targetWidth > maxWidth || targetHeight > maxHeight) {
        if (targetWidth / targetHeight > maxWidth / maxHeight) {
          targetHeight = Math.round(maxWidth * (targetHeight / targetWidth))
          targetWidth = maxWidth
        } else {
          targetHeight = maxHeight
          targetWidth = Math.round(maxHeight * (targetWidth / targetHeight))
        }
      }
      canvas.width = targetWidth
      canvas.height = targetHeight
      canvas.getContext('2d').drawImage(img, 0, 0, targetWidth, targetHeight)
      canvas.toBlob(blob => {
        if (type === 'blobUrl') {
          resolve(URL.createObjectURL(blob))
        } else if (type === 'blob') {
          resolve(blob)
        }
      })
    }
    img.setAttribute('crossOrigin', 'Anonymous')
    img.src = url
  })
  let content = []
  for (let url of urls) {
    content.push(await getContent(url))
  }
  return content
}

export const downloadFile = (fileName, urlData, target) => {
  let aLink = document.createElement('a')
  if (fileName) {
    aLink.download = fileName
  }
  if (target) {
    aLink.target = target
  }
  aLink.href = urlData
  aLink.click()
}

export const fileTypeCheck = (e, operation, onError) => {
  let acceptTypes = e.target.getAttribute('accept')
  acceptTypes = acceptTypes ? acceptTypes.split(',') : null
  let extension = e.target.getAttribute('extension')
  extension = extension ? extension.split(',') : null
  let match = (arys, s) => {
    for (let ary of arys) {
      let rgx = new RegExp(ary)
      if (rgx.test(s)) {
        return true
      }
    }
    return false
  }
  for (let file of e.target.files) {
    let fileType = file.type
    let fileExtension = file.name.split('.')
    fileExtension = fileExtension[fileExtension.length - 1]
    if (extension && !match(extension, fileExtension)) {
      e.target.value = ''
      if (onError) {
        onError(e, extension)
      }
      return
    }
    if (acceptTypes && !match(acceptTypes, fileType)) {
      e.target.value = ''
      if (onError) {
        onError(e, acceptTypes)
      }
      return
    }
  }
  operation(e)
}

export const dateFormat = (date, fmt) => {
  date.setHours(date.getHours() - (date.getTimezoneOffset() - (new Date()).getTimezoneOffset()) / 60)
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
    'q+': Math.floor((date.getMonth() + 3) / 3),
    'S': date.getMilliseconds()
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export const secondFormat = (second, fmt) => {
  const o = {
    'h+': Math.floor(second / 3600),
    'm+': Math.floor(second % 3600 / 60),
    's+': Math.floor(second % 3600 % 60)
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}

export const toFormdata = (object, needEmpty = false) => {
  let formData = new FormData()
  for (let kv of Object.entries(object)) {
    if (needEmpty || (kv[1] !== null && kv[1] !== undefined)) {
      if (kv[1] instanceof Array) {
        for (let data of kv[1]) {
          formData.append(kv[0] + '[]', data)
        }
      } else {
        formData.append(kv[0], kv[1])
      }
    }
  }
  return formData
}

/* eslint-disable */
const _XLSX = XLSX
/* eslint-enable */

export const xlsxToJson = async files => {
  if (!files) {
    return
  }
  const getContent = file => new Promise(resolve => {
    let reader = new FileReader()
    reader.onload = e => {
      let data = e.target.result
      let wb = _XLSX.read(data, {
        type: 'binary'
      })
      resolve(_XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]))
    }
    reader.readAsBinaryString(file)
  })
  let jsons = []
  for (let file of files) {
    jsons.push(await getContent(file))
  }
  return jsons
}



// WEBPACK FOOTER //
// ./src/constants/global/util.js